import React, { useState } from 'react'

import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import { generateDisplayFields } from "utils/fieldMapper";
import { FilterStatus } from "utils/FilterStatus"
import DataTable from 'Common/DataTable/DataTable';
import feilds from "../../json/RoomCheckInFields.json"
import { GetAllBookings } from 'adminApi/RoomCheckInApi/RoomCheckIn';
import { useRoleVerify } from 'Common/RoleVerify';
import useRoomTableConfig from './useCheckInTableConfig';

const RoomCheckInTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = feilds

  // Fetch Hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAllBookings, {
    page,
    limit,
    search: debouncedSearch,
    title: "Room Checkin List",
  });

  // Auto-generate display fields 
  const displayFields = generateDisplayFields(tabledata);

  const filterdata = FilterStatus(data);

  // Table Hook
  const { formattedData, columns } = useRoomTableConfig({
    data: filterdata,
    page,
    limit,
    canShowAction,
    refetch,
    IsDelete: false,
    isView: true, 
    config: {
      entityName: "Room Checkin",
      editUrl: "update-checkin",
      idKey: "booked_id",
      deleteApi: '',
      displayFields,
      ViewUrl: 'view-checkin',
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => { setPage(p) };

  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };


  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default RoomCheckInTable